<template>
  <div class="account">
    <!-- <div class="header_container">
        <h3>{{ $t('reviewOrder') }}</h3>
    </div> -->
    <div class="main-content">
      <div class="account-list-container">
        <div class="section-header text-center mobile-hide">
          <h2>{{ $t('orderList') }}</h2>
        </div>
        <div v-show="loggedIn===true" class="customers_acc">
          <div class="grid">
            <div>
              <div>
                <p v-show="this.$store.state.orders.orderList.length===0">{{ $t('noPlacedOrder') }}</p>
                <div style="display: inline-block; width: 100%;">
                  <p style="margin-left: 10px">{{ $t('orderTime') }}</p>
                  <el-date-picker
                    v-model="date"
                    type="daterange"
                    range-separator="To"
                    start-placeholder="Start date"
                    end-placeholder="End date"
                    style="width:70%"
                    @change="updateDate"
                  />
                </div>
              </div>
              <div style="display: inline-block; width: 20%;">
                <p style="margin-left: 10px">{{ $t('shipmentType') }}</p>
                <el-select class="selectTime" v-model="type" v-bind:placeholder="$t('shipmentType')" value="" @change="updateType" style="width:auto">
                  <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="$t(item.label)"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div style="display: inline-block; width: 20%;">
                <p style="margin-left: 10px">{{ $t('perPage') }}</p>
                <el-select v-model="limit" v-bind:placeholder="$t('limit')" value="" @change="updateLimit" style="width:auto">
                  <el-option
                    v-for="item in limitOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div style="display: inline-block; width: 20%;">
                <p style="margin-left: 10px">{{ $t('Bol') }}</p>
                <el-select v-model="hasBol" v-bind:placeholder="$t('bol')" value="" @change="updateBol" style="width:auto">
                  <el-option
                    v-for="item in BolOptions"
                    :key="item.value"
                    :label="$t(item.label)"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <button class="btn" @click="exportOrder()">
                <span>{{ $t("export") }}</span>
              </button>
              <table v-show="this.$store.state.orders.orderList.length>0" class="responsive-table" style="marginTop:30px">
                <thead>
                  <tr>
                    <th>{{ $t('orderNo') }}</th>
                    <th>{{ $t('orderDate') }}</th>
                    <th>{{ $t('delivery') }}</th>
                    <th>{{ $t('paymentStatus') }}</th>
                    <th>{{ $t('fulfillmentStatus') }}</th>
                    <th>{{ $t('total') }}</th>
                  </tr>
                </thead>
                <tbody>
                <tr v-for="(order, index) in this.$store.state.orders.orderList" data-index="index" :key="index">
                  <!-- <td data-label="Order"> -->
                  <td v-bind:data-label="$t('order')">
                    <p class="btn" @click="goToOrderDetail(order.SalesOrder_id)">
                      #{{order.SONum}}
                    </p>
                  </td>
                  <td v-bind:data-label="$t('date')">{{order.OrderDate}}</td>
                  <td v-bind:data-label="$t('delivery')" nowrap="nowrap">
                    {{order.DispatchDate}}
                  </td>
                  <td v-bind:data-label="$t('paymentStatus')">{{order.PaymentStatus}}</td>
                  <td v-if='order.SaleStatus==="Delivered"' v-bind:data-label="$t('fulfillmentStatus')">{{ $t('inTransit') }}</td>
                  <td v-if='order.SaleStatus!=="Delivered"' v-bind:data-label="$t('fulfillmentStatus')">{{order.SaleStatus}}</td>
                  <td v-bind:data-label="$t('total')">${{order.FinalPrice}}</td>
                </tr>
                </tbody>
              </table>
              <pagination
                :totalPages="pages"
                :total="count"
                :currentPage="currentPage"
                @pagechanged="onPageChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> 
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import pagination from "../../components/pagination";
import breadcrumb from '../../components/breadcrumb';

export default {
  name: "account-order",
  components: {
    breadcrumb,
    pagination,
  },
  data(){
    return{
      orderList:[],
      loaded: false,
      currentPage: 1,
      date: '',
      start_date: '',
      end_date: '',
      type: '',
      typeOptions: [
        { value: '&mobile=False&outbound=False', label: 'inbound'},
        { value: '&mobile=False&outbound=True', label: 'outbound'},
        { value: '&mobile=True&outbound=True', label: 'mso'},
        { value: '', label: 'all'},
      ],
      limit: '10',
      limitOptions: [
        { value: '10', label: '10' },
        { value: '30', label: '30' },
        { value: '50', label: '50' },
        { value: '100', label: '100'},
      ],
      hasBol: null, // filter by ProNum
      BolOptions: [
        { value: null, label: '--' },
        { value: true, label: 'hasBol' }, // shipmenthasBol
        { value: false, label: 'noBol' }, // quote
      ],
      
      activeTabName: null,
      list:[],

    }
  },
  methods:{
    ...mapMutations('auth', ['logout', 'updateLoginStatus', 'updateActiveOrder']),
    ...mapMutations('orders', ['updateActiveOrder']),
    ...mapActions('orders', ['fetchOrderByTimeFrame','fetchOrderDetails','cancelOrder','fetchConsolidatedOrders']),
    
    navTo(id) {
    },
    goToOrderDetail(id) {
      this.updateActiveOrder(id);
      this.$router.push({name: 'order', params: {order_id: id}});
    },
    updateDate(value) {
      this.start_date = moment(value[0]).format();
      this.end_date = moment(value[1]).format();
      this.updateFilter();
    },
    updateType(value) {
      this.type = value;
      this.updateFilter();
    },
    updateLimit(value) {
      this.limit = value;
      this.updateFilter();
    },
    updateBol(value) {
      this.hasBol = value;
      this.updateFilter();
    },
    updateFilter() {
      this.$store.dispatch('orders/fetchOrderByTimeFrame',[this.start_date, this.end_date, this.type, this.limit, this.currentPage, this.hasBol, false]);
    },
    exportOrder() {
      let start = '';
      let end = '';
      
      const token = localStorage.getItem('token');
      
      if (this.start_date && this.end_date) {
        start = `&start_date=${start_date}`;
        end = `&end_date=${end_date}`;
      }
      
      // this.$store.dispatch('orders/fetchOrderByTimeFrame',[this.start_date, this.end_date, this.type, this.limit, this.currentPage, this.hasBol, true]);
      
      const url = `https://ying-scm.truckxi.com/api/v1/mobile/overseas-order/?limit=${this.limit}&page=1${start}${end}&export=true&JWT=${token}`;
      window.location.href = url;
    },
    onPageChange(page) {
      this.currentPage = page;
      this.updateFilter();
      window.scrollTo(0, 0);
    }
  },
  mounted() {
    this.$store.dispatch('orders/fetchOrderByTimeFrame',[this.start_date, this.end_date, this.type, this.limit, this.currentPage, this.hasBol, false]);
  },
  computed: mapState({
    loggedIn: state => state.auth.loggedIn,
    pages: state => state.orders.orderListPaginate,
    count: state => state.orders.orderListCount,
  }),
  watch: {
    '$store.state.orders.orderList': {
      immidiate: true,
      handler(newval) {
        this.loaded = true;
      }
    }  
  }
}
</script>
<style scoped lang="less">
@import "../../assets/css/accountList.less";
// @import "../../assets/css/warehouseOrderHistory.less";
</style>



// WEBPACK FOOTER //
// src/view/Profile/order.vue